<template>
	<div id="app">
		<router-view />
		<Loading v-show="isLoading"></Loading>
	</div>
</template>

<script>
	import Loading from '@/components/Loading';
	
	export default {
		components: {
			Loading
		},
		data() {
			return {
			}
		},
		computed: {
			isLoading() {
				return this.$store.getters['commonStore/isLoading'];
			}
		},
		methods: {
		},
		mounted () {
			this.$store.commit('commonStore/setLoading', false);
		}
	}
</script>

<style lang="scss">
	html, body, #app {
		height: 100%;
		color: #333;
	}
	body {
		-webkit-touch-callout:none; // リンク長押しのポップアップを無効化
		-webkit-user-select:none; // テキスト長押しの選択ボックスを無効化
		margin: 0;
	}
	.form-control:focus {
		border-color: #66EFE9;
		outline: none;
		box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
	}
	#app, input, textarea {
		/*font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", "Hiragino Kaku Gothic ProN", "BIZ UDPGothic", メイリオ, meiryo, "M PLUS 1p", sans-serif;*/
		/*font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", "Hiragino Kaku Gothic ProN", "BIZ UDPGothic", メイリオ, meiryo, "M PLUS 1p", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";*/
		font-family: 'BIZ UDPGothic', 'Migu 1C', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Hiragino Kaku Gothic ProN', メイリオ, meiryo, sans-serif;
	}
</style>
<style lang="scss" scoped>
	#header {
		background: #66D4DD;
		height: 50px;
		ul {
			display: flex;
			align-items: center;
			height: 100%;
			#organization {
				color: #FFF;
				display: flex;
				padding-left: 15px;
				&::after {
					content: "";
					display: block;
					width: 0;
					height: 0;
					border-style: solid;
					border-width: 6px 5px 0 5px;
					border-color: #FFF transparent transparent transparent;
					margin: 4px 0 0 5px;
				}
			}
		}
	}
</style>
